import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectAllocatedBudget(
    request: Boundaries["editProjectAllocatedBudget"]["request"],
  ): void;
}

function useEditProjectAllocatedBudget(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectAllocatedBudgetRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectAllocatedBudgetRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectAllocatedBudgetRequestFailure(project),
    ),
    editProjectAllocatedBudget: core.editProjectAllocatedBudget,
  };
}

export { useEditProjectAllocatedBudget };
